import {DG_axios} from "../../../custom/axios";
import {DG_axiosNormal} from "../../../custom/axios/normal";

const baseURL = `/dogoo/payment-history-rest/v2.0/payment-customer`
const baseTPURL = `/dogoo/transaction-rest/v2.0/transaction-payment`


export async function getPaymentCustomer(checkView) {
    const response = await DG_axios.get(baseURL, {
        params: {
            checkView
        }
    })
    return response?.data || []
}
export async function addTransactionPayment(transaction) {
    const response = await DG_axiosNormal.post(baseTPURL, transaction)
    return response?.data || []
}
